<template>
  <vs-popup class="confirm-work-order-pop-up"
            title="WO DRAG TO:"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow id="confirm-work-order-pop-up">
      <div class="vx-row mb-3 mt-2">
          <div class="vx-col w-full md:mb-0">
            <small class="label"> Start Time : </small>
            <vs-input readonly v-model="start_time" class="w-full required" />
          </div>
      </div>
      <div class="vx-row mb-3 mt-5">
        <div class="vx-col w-full md:mb-0">
          <small class="label"> Start Date : </small>
          <vs-input readonly v-model="work_order_date" class="w-full required" />
        </div>
      </div>

      <div class="vx-row mb-3">
          <div class="vx-col w-full md:mb-0">
              <small class="label">Production Line :</small>
              <v-select :clearable="false" name="production_line_name" placeholder=""
                        label="production_line_name" v-model="data.ProjectId" :reduce="option => option.id"
                        :options="live_production_lines" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
          </div>
      </div>
      <div class="flex flex-wrap items-center justify-end mt-8" >
        <vs-button @click="onClickConfirm" id="save_change_button" button="submit" class="ml-auto mt-2">Confirm</vs-button>
        <vs-button @click="open =false" class="ml-4 mt-2" type="border" color="warning">Cancel</vs-button>
      </div>

    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const ManufacturingRepository = RepositoryFactory.get('manufacturing')
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import moment from 'moment'

  function initialState() {
    return {
      open: false,
      createForm: {},
      form: {},
      id: '',
      production_line_id: '',
      taken_slots: [],
      data: null,
      start_time: '',
      work_order_date: '',
      live_production_lines: []
    }
  }

export default {
  name: 'ConfirmWorkOrderPopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (data) {
      try {
        await Object.assign(this.$data, initialState())
        await this.getLiveProductionLineList()
        this.data = data
        this.open = true;
        this.work_order_date = moment(this.data.StartTime).format('DD/MM/YYYY')
        this.start_time = moment(this.data.StartTime).format('HH:mm')
      } catch (error) {

      }
    },

    async onClickConfirm (){
      const vue = this
      await this.$vs.loading({
        container: '#confirm-work-order-pop-up',
        scale: 0.45
      })
       try {
         const payload = {
           work_order_date: this.work_order_date,
           start_time: moment(this.start_time, 'HH:mm').utc().format('HH:mm'),
           production_line_id: this.data.ProjectId
         }
         await ManufacturingRepository.updateWorkOrderDateTime(this.data.id, payload);
         this.showSuccessMessage('Work order update successfully')
         this.open = false;
         await vue.$emit('refresh')
         this.$vs.loading.close('#confirm-work-order-pop-up > .con-vs-loading')
       }catch (e) {
         this.$vs.loading.close('#confirm-work-order-pop-up > .con-vs-loading')
         this.convertAndNotifyError(e)
       }
    },
    async getLiveProductionLineList() {
        this.$vs.loading()
        this.live_production_lines = (await ManufacturingRepository.getLiveProductionLineList(1, 50)).data.data;
        this.$vs.loading.close()
    },
    // async getLiveProductionLineList() {
    //     await this.$vs.loading()
    //     try {
    //       await this.fetchSettings()
    //       const {data} = await ManufacturingRepository.getLiveProductionLineList(1, '', 50)
    //       this.live_production_lines =  data.data
    //       this.projectResourceDataSource =  this.live_production_lines.map((m) => {
    //         return {text: m.production_line_code, id: m.id, color: '#28C76F', production_line_name: m.production_line_name}
    //       })
    //     } catch (e) {
    //     }
    //     this.$vs.loading.close()
    // },
  },
  watch: {

  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
    flatPickr
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .confirm-work-order-pop-up >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 30% !important;
  }

</style>
